import {
  useTheme,
  Typography,
  IconButton,
  Collapse,
  Stack,
} from "@mui/material";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { getUSCurrency } from "@/global/utils/getUSCurrency";
import { SubtotalListItem } from "./SubtotalListItem";
import React from "react";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { ServiceFeeState } from "@/global/store/data/purchaseSeats/serviceFee";

export interface TotalAmountWithBreakdownProps {
  totalAmountBreakdown?: ServiceFeeState["totalAmountBreakdown"];
  allInPrice?: number;
}

export function TotalAmountWithBreakdown(props: TotalAmountWithBreakdownProps) {
  const theme = useTheme();
  const teamConfig = useTeamConfig();
  const config = teamConfig?.purchaseSeatConfigs?.checkout?.totalAmountBreakdown; // prettier-ignore
  const breakdown = props?.totalAmountBreakdown;
  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <Stack>
      <Stack spacing={0.5} direction={"row"} alignItems={"center"}>
        <Stack
          flex={1}
          direction={"row"}
          spacing={1}
          justifyContent={"space-between"}
        >
          <Typography variant="body1" fontWeight={700} color="text.secondary">
            {config?.totalAmountLabel || "Total Amount"}
          </Typography>
          <Typography variant="body1" color="text.primary" fontWeight={700}>
            {getUSCurrency(props?.allInPrice || 0)}
          </Typography>
        </Stack>

        <IconButton
          size="small"
          onClick={() => setIsOpen(!isOpen)}
          sx={{
            transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform 0.3s ease",
            marginBottom: "0px",
            padding: "0px",
            "& svg": { fontSize: "28px" },
          }}
        >
          <MdOutlineKeyboardArrowDown />
        </IconButton>
      </Stack>
      <Collapse in={isOpen}>
        <Stack py={1.5}>
          <Stack
            p={1.5}
            border={`1px solid ${theme.palette.divider}`}
            borderRadius={1}
          >
            <Typography
              variant="body1"
              fontWeight={700}
              color="text.primary"
              mb={1.5}
            >
              Order Details
            </Typography>

            {breakdown?.totalTicketAmount &&
            breakdown?.totalTicketAmount > 0 ? (
              <SubtotalListItem
                label={config?.ticketTotalLabel || "Tickets Total"}
                value={getUSCurrency(breakdown.totalTicketAmount)}
              />
            ) : null}

            {breakdown?.totalTicketFeesAmount &&
            breakdown.totalTicketFeesAmount > 0 ? (
              <SubtotalListItem
                label={config?.ticketFeesLabel || "Ticket Fees"}
                value={getUSCurrency(breakdown.totalTicketFeesAmount)}
              />
            ) : null}

            {breakdown?.totalTaxAmount && breakdown.totalTaxAmount > 0 ? (
              <SubtotalListItem
                label={config?.taxesLabel || "Taxes"}
                value={getUSCurrency(breakdown.totalTaxAmount)}
              />
            ) : null}
          </Stack>
        </Stack>
      </Collapse>
    </Stack>
  );
}
